import { useShowContext } from 'framework/show';
import { STAFFING_PRIORIRY_ZONES_ALIASES, StaffingDataType } from 'domain/shared/staffing';
import { ZONE_LABELS } from 'domain/staffing/dashboard/constants';
import { useDashboardModals } from 'framework/ui/dashboard';
import { ChangeZoneCallbacks } from 'domain/shared/core/dashboard';

export const useZonesManagement = () => {
  const { data } = useShowContext<StaffingDataType>();
  const { openModal } = useDashboardModals();

  const projectData = data.getData();
  const currentZone =
    (projectData?.currentZone as keyof typeof STAFFING_PRIORIRY_ZONES_ALIASES) || projectData?.staffingRisk?.priority;
  const allZones = Object.keys(STAFFING_PRIORIRY_ZONES_ALIASES);

  const zoneOptions = allZones.map(zone => ({
    key: `zone-${zone}`,
    label: ZONE_LABELS[zone as keyof typeof STAFFING_PRIORIRY_ZONES_ALIASES],
    disabled: zone === currentZone,
    onClick: () => openModal('issues', { projectData }),
  }));

  const changeZoneCallbacks: ChangeZoneCallbacks = {
    onSubmit: async () => {
      openModal('issues', { projectData });
    },
    onClose: () => {},
  };

  return {
    zoneOptions,
    zones: ZONE_LABELS,
    changeZoneCallbacks,
  };
};
